import { render } from "./staff-leave.vue?vue&type=template&id=24e806ab"
import script from "./staff-leave.vue?vue&type=script&lang=js"
export * from "./staff-leave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__